import {
	Box,
	Container,
	Divider,
	LinearProgress,
	makeStyles,
	Typography
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import React, { useEffect, useState } from 'react';
import { useActions, useValues } from 'kea';

import grouplogic from 'src/store/group';

import Page from 'src/components/Page';
import Vehicles from './vehicles';
import Assets from './assets';
import Geofences from './geofences';
import Toolbar from './Toolbar';
import Users from './users';
import Alerts from './alerts';
import CreateGroup from './CreateGroup';
// import ProfileDetails from './ProfileDetails';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	}
}));

const Groups = () => {
	const classes = useStyles();

	const [selectedGroup, setSelectedGroup] = useState(null);
	const [index, setIndex] = useState(null);

	const { groups } = useValues(grouplogic);
	const { fetchAll } = useActions(grouplogic);

	useEffect(() => {
		groups ?? fetchAll();
	}, []) // eslint-disable-line

	useEffect(() => {
		if (index !== null) {
			setSelectedGroup(groups[index] || null);
		}
	}, [groups])

	const handle_select_filter = (index) => {
		setSelectedGroup(groups[index] || null);
		setIndex(index)
	}

	//asdsad
	return (
		<Page
			className={classes.root}
			title="Groups"
		>
			{
				groups === null
					?
					<></>
					:
					<Container maxWidth={false} style={{ paddingBottom: 20 }}>
						<Box mt={3} >
							<Typography variant="h3" gutterBottom>
								Groups
							</Typography>
							<Divider />
						</Box>
						<CreateGroup />
						<Toolbar select_filter={handle_select_filter} rows={groups} />
						<Box mt={3}>
							{
								selectedGroup ?
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12} md={12} lg={6}>
											<Users selectedGroup={selectedGroup} users={selectedGroup.users} />
										</Grid>
										{/* <Grid item xs={12} sm={12} md={12} lg={4}>
											<Drivers selectedGroup={selectedGroup} drivers={selectedGroup.drivers} />
										</Grid> */}
										<Grid item xs={12} sm={12} md={12} lg={6}>
											<Vehicles selectedGroup={selectedGroup} vehicles={selectedGroup.vehicles} />
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={4}>
											<Assets selectedGroup={selectedGroup} assets={selectedGroup.assets} />
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={4}>
											<Geofences selectedGroup={selectedGroup} geofences={selectedGroup.geofences} />
										</Grid>
										<Grid item xs={12} sm={12} md={12} lg={4}>
											<Alerts selectedGroup={selectedGroup} alerts={selectedGroup.alerts} />
										</Grid>
									</Grid>
									:
									null
							}
						</Box>
					</Container>
			}
		</Page>
	);
};

export default Groups;
